export default __webpack_public_path__ + "static/media/bell.91c9f67f.svg";